import { useState } from "react";

const useInput = (validationType) => {
    const [enteredValue, setEnteredValue] = useState('');
    const [valueIsTouched, setValueIsTouched] = useState(false);

    let valueIsValid = false;

    if (validationType === "blankval") {
        valueIsValid = enteredValue.trim() !== '';
    } else if (validationType === "numcheck") {
        valueIsValid = enteredValue.trim() !== '' && enteredValue.length >= 10;
    } else if (validationType === "emailcheck") {
        valueIsValid = enteredValue.includes('@') && enteredValue.trim() !== '';
    }

    const hasError = !valueIsValid && valueIsTouched;

    const inputValueHandler = (e) => {
        setValueIsTouched(true);
        setEnteredValue(e.target.value);
    }

    const inputBlurHandler = () => {
        setValueIsTouched(true);
    }

    const reset = () => {
        setEnteredValue('');
        setValueIsTouched(false);
    }

    return {
        value: enteredValue,
        isValid: valueIsValid,
        hasTouched: valueIsTouched,
        hasError: hasError,
        inputBlurHandler,
        inputValueHandler,
        reset
    };
}

export default useInput;
